import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Template} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {SpaceDotsMenu} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/spaces/SpaceDotsMenu';
import {UserBar} from '@mintdata-wsp/wsp/ui/views/workspace/userBar/UserBar';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Route, Switch} from 'react-router';
import {Link} from 'react-router-dom';
import {SearchButton} from '@mintdata-wsp/wsp/ui/views/workspace/home/topbar/SearchButton';

const styles = require('./WspTopbar.less');
const cx = classnames.bind(styles);

interface Props
{
    match:any
}

@observer
export class WspTopbar extends React.Component<Props, any>
{
    private _getTemplateName = ():string =>
    {
        const {match} = this.props;

        const {templateName} = match.params;

        const template:Template = controllers.ui.mainPage.getTemplateByName(templateName);

        return template ? template.shortTitle : 'Template';
    };

    private _getSpaceName = ():string =>
    {
        const {currentProject} = rootState.ui.mainPage;

        return currentProject ? currentProject.name : 'Spaces';
    };

    @action
    private _onClickMenuBtn = (e:React.MouseEvent<HTMLElement>) =>
    {
        controllers.ui.mainPage.toggleMobileMenuVisibility();
    };

    render():JSX.Element
    {
        // const {match} = this.props;
        const {isMobileMenuVisible} = rootState.ui.mainPage;

        const {currentProject} = rootState.ui.mainPage;

        return (
            <Row className={cx(styles.topbar)}>

                <Row className={cx(styles.logoWrapper)}>
                    <Link
                        to={paths.index()}
                        className={cx(styles.logoLink)}
                    >
                        <MDIcon className={cx('logo26')} name={MDIcons.logo.MintDataLogo26} />
                    </Link>
                </Row>

                <Row className={cx(styles.content)}>

                    <div className={cx(styles.titleWrapper)}>
                        <Switch>
                            <Route exact path={`${paths.index()}`}>
                                <div className={cx(styles.title)}>
                                    Home
                                </div>
                            </Route>
                            <Route exact path={`${paths.search()}`}>
                                <div className={styles.title}>
                                    Search
                                </div>
                            </Route>
                            <Route exact path={`${paths.designs()}`}>
                                <div className={cx(styles.title)}>
                                    Designs
                                </div>
                            </Route>
                            <Route exact path={`${paths.template(':templateName')}`}>
                                <Row className={cx(styles.titleSpaceWrapper)}>
                                    <div className={cx(styles.titleSpace)}>
                                        {this._getTemplateName()}
                                    </div>
                                </Row>
                            </Route>
                            <Route exact path={`${paths.templates()}`}>
                                <div className={cx(styles.title)}>
                                    Templates
                                </div>
                            </Route>
                            <Route exact path={`${paths.applications()}`}>
                                <div className={cx(styles.title)}>
                                    Applications
                                </div>
                            </Route>

                            <Route path={`${paths.spaces(':projectId')}`}>
                                <Row className={cx(styles.titleSpaceWrapper)}>
                                    <div className={cx(styles.titleSpace)}>
                                        {this._getSpaceName()}
                                    </div>
                                    <SpaceDotsMenu
                                        className={styles.dotsMenu}
                                        project={currentProject}
                                    />
                                </Row>
                            </Route>
                            <Route path={`${paths.settings()}`}>
                                <div className={cx(styles.title)}>
                                    Settings
                                </div>
                            </Route>

                            <Route path="*">
                                <div className={cx(styles.title)}>
                                    404
                                </div>
                            </Route>
                        </Switch>
                    </div>

                    <div className={cx(styles.tools)}>
                        <Row>
                            <SearchButton className="desktop" />
                        </Row>
                        <UserBar className={styles.userBar} />
                    </div>

                </Row>

                <Row
                    className={styles.mobileMenuBtn}
                >
                    <SearchButton className="mobile" />
                    <MDIcon
                        name={isMobileMenuVisible ? MDIcons.common.Close : MDIcons.common.Menu}
                        className={cx(styles.mobileMenuIcon, {isVisible: isMobileMenuVisible})}
                        size={MDIconSize.large}
                        onClick={this._onClickMenuBtn}
                    />
                </Row>

            </Row>
        );
    }
}
